//@flow
import * as React from 'react'
import type { InstructionAndDocLink$Props } from '../ProjectDemeter/flowTypes'

const InstructionAndDocLink=(props:InstructionAndDocLink$Props)=>{
    return (
        <div className="row">
            <div className="col-sm">
                <a href={'https://docs.google.com/document/d/e/2PACX-1vSRR5NbK3NwdEa7jgcPu7xk8O3nIvEu7VDNC72ihOqrZJoFCckhb4GvrbAF0iNr5_RFFKBc4txZh2MA/pub?embedded=true'} target='_blank' >Instructions</a>
                &nbsp;&nbsp;&nbsp;
                <a href={props.docLink} target='_blank' >PDF Link</a>
                <br />
                <br />
            </div>
        </div> 
    )
}

export default InstructionAndDocLink


// WEBPACK FOOTER //
// ./src/views/ProjectHermes/InstructionAndDocLink.js